// extracted by mini-css-extract-plugin
module.exports = {"root":"StarterBlade-module--root--eUJQc","linkContainer":"StarterBlade-module--linkContainer--s3ARf"};